import React, {useState, useEffect} from 'react'
import P from '../../../assets/python.jpg'
import M from '../../../assets/makeup.jpg'
import W from '../../../assets/web.jpg'
import CourseCard, { CourseCardSkeleton } from '../../../Components/CourseCard'
import { useQuery } from 'react-query'
import axios from 'axios'
import { baseUrl, path } from '../../../constants'
import { api } from '../../../api'

export default function Popular({setSelectedCourse}) {
    // const {isLoading, data, refetch} = useQuery('fetchPopularCourses', () => 
    //     axios(baseUrl + path.popularCourses)
    // )
    // console.log(data)
    const [courses, setCourses] = useState([])
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        api.get(path.courses + '?type=popular').then(response => {
            let data = response.data
            if(data.success){
                setCourses(data.courses)
            }
        }).finally(() => setLoading(false))
    }, [])

  return (
    <div className='flex flex-col gap-5 p-5'>
        {/* <p className='text-black text-xl font-bold tracking-wide'>Popular Courses</p> */}
        {/* <CourseChooser /> */}
        <Courses courses={courses} isLoading={loading} setSelectedCourse={setSelectedCourse} />
    </div>
  )
}

export function CourseChooser({courses}){
    return (
        <div className='flex gap-5 items-center'>
            {courses.map(item => (
                <button className='bg-[#f7f9fa] text-black text-sm p-2 rounded-sm outline-none border-none'>{item}</button>
            ))}
        </div>
    )
}

// const courses = [
//     {name: 'Python for begginers', instructor: 'Fuad hy', rating: {value: 4.5, count: 400}, price: 700, image: P},
//     {name: 'Makeup tutorial', instructor: 'Fuad hy', rating: {value: 3.5, count: 400}, price: 700, image: M}
// ]

function Courses({courses, isLoading, setSelectedCourse}){
    return (
        <div className='grid grid-cols-[repeat(auto-fill,minmax(320px,1fr))] max-md:grid-cols-[repeat(auto-fill,minmax(350px,1fr))] gap-x-4 gap-y-4 place-items-center'>
            { isLoading ? new Array(4).fill(0).map(course => (
                <CourseCardSkeleton />
            )) : courses.map(course => (
                <CourseCard course={course} setSelectedCourse={setSelectedCourse} />
            ))}
        </div>
    )
}